var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Visualizar beneficiários", width: 1000 },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "modal" },
          [
            _c("informacoes-beneficiarios", {
              attrs: {
                beneficiarios: _vm.beneficiarios,
                cadastroOriginal: _vm.cadastroOriginal,
                canRemove: true
              },
              on: { updateBeneficiariosLista: _vm.updateBeneficiariosLista }
            })
          ],
          1
        )
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: {
                  id: "cancelarRemocao",
                  type: "default",
                  size: "small"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("closeModal")
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: {
                  id: "confirmarRemocao",
                  type: "success",
                  size: "small"
                },
                on: { click: _vm.confirmarRemocao }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("b", [_vm._v("  Confirmar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-205266f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205266f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalBeneficiario.vue
// module id = null
// module chunks = 